export default class {
  constructor() {
    this.options = {
      holder: '#preloader',
			lineClass: 'anim-line',
			easing: 'linear',
			firstStepDelay: 1000,
			lines: [
  			{
  				width: 25,
  				speed: 2000,
  				steps: [
  					{
  						from: [20, 0],
  						to: [20, 82]
  					},
  					{
  						from: [20, 82],
  						to: [44, 82]
  					},
  					{
  						from: [44, 82],
  						to: [44, 70]
  					}
  				]
  			},
  			{
  				width: 25,
  				speed: 2000,
  				steps: [
  					{
  						from: [0, 30],
  						to: [75, 30]
  					},
  					{
  						from: [75, 30],
  						to: [75, 70]
  					}
  				]
  			},
  			{
  				width: 2,
  				speed: 2000,
  				steps: [
  					{
  						from: [80, 0],
  						to: [80, 70]
  					}
  				]
  			},
  			{
  				width: 2,
  				speed: 1000,
  				steps: [
  					{
  						from: [100, 70],
  						to: [28, 70]
  					},
  					{
  						from: [28, 70],
  						to: [28, 0]
  					},
  				]
  			},
  		]
		};
    this.eventComplete = new Event('preloaderComplete');
  }

  init() {
		this.findElements();
		this.calcAverageSpeed();
		this.addLines();
    this.hideAnimationHolder();
	}

	findElements() {
		this.holder = document.querySelector(this.options.holder);
	}

	calcAverageSpeed() {
		let self = this,
			vh = this.holder.offsetHeight,
			vw = this.holder.offsetWidth;
		this.options.lines.forEach(function(line) {
			let delay = self.options.firstStepDelay;
			line.pices = [];
			line.fullDistance = [];
			line.animTime = [];
			line.stepDelay = [];
			line.steps.forEach(function(step) {
				line.pices.push(Math.floor(self.returnDistance(step) / 100 * (self.returnDirection(step) === 'y' ? vh : vw)));
			});
			line.fullDistance = line.pices.reduce(function(acc, it) {return acc += it;});
			line.pices.forEach(function(it) {
				let t = (Math.floor(100 / line.fullDistance * it)) / 100 * line.speed;
				line.animTime.push(t);
				line.stepDelay.push(delay);
				delay += t;
			});
		});
	}

	addLines() {
		let self = this;
		this.options.lines.forEach(function(line) {
			line.steps.forEach(function(step, i) {
				self.addLine(line, step, self.returnDirection(step), i);
			});
		});
	}

	addLine(line, step, dir, lineCount) {
		let $line = document.createElement('span');
		$line.classList.add(this.options.lineClass)
    this.holder.append($line);
    const styles = this.returnLineStyles(line, step, dir);
		for (let property in styles) {
      const originProperty = this.toCamelCase(property);
      $line.style[originProperty] = styles[property];
    }
		this.animateLine(line, step, dir, $line, lineCount);
	}

  toCamelCase(string) {
    const letters = string.split('');
    letters.forEach((letter, i) => {
      if (letter == '-') {
        letters.splice(i, 1)
        letters[i] = letters[i].toUpperCase();
      }
    });
    return letters.join('')
  }

	returnLineStyles(line, step, dir, $line) {
		let margin = dir === 'x' ? 'margin-top' : 'margin-left',
			posProp,
      lineWidth = document.documentElement.clientWidth < 640 ? line.width / 2 : line.width,
		  obj = {
				height: dir === 'x' ? lineWidth + 'px' : 0,
				width: dir === 'y' ? lineWidth + 'px' : 0,
				[margin]: -lineWidth + 'px'
			}
		if (dir === 'x') {
			posProp = returnProp(0, ['left', 'right']);
			setProp(0, 'left');
			obj.top = step.from[1] + '%';
		}
		if (dir === 'y') {
			posProp = returnProp(1, ['top', 'bottom']);
			setProp(1, 'top');
			obj.left = step.from[0] + '%';
		}
		return obj;
		function returnProp(ind, props) {
			return step.from[ind] < step.to[ind] ? props[0] : props[1];
		}
		function setProp(ind, prop) {
			obj[posProp] = posProp === prop ? step.from[ind] + '%' : (100 - step.from[ind]) + '%';
		}
	}

	returnDirection(step) {
		return (step.from[0] !== step.to[0]) ? 'x' : (step.from[1] !== step.to[1]) ? 'y' : null;
	}

	returnDistance(step) {
		let d = this.returnDirection(step) === 'x' ? 0 : 1,
			from = step.from[d],
			to = step.to[d];
		return Math.abs(from > to ? from - to : from - to);
	}

	animateLine(line, step, dir, $line, lineCount) {
		let animProp = dir === 'y' ? 'height' : dir === 'x' ? 'width' : null;
    $line.style.transition = animProp + ' ' + line.animTime[lineCount] + 'ms ' + this.options.easing + ' ' + line.stepDelay[lineCount] + 'ms';
    setTimeout(() => {
      $line.style[animProp] = this.returnDistance(step) + '%';
    }, 10)
	}

	hideAnimationHolder() {
    setTimeout(() => {
      this.holder.style.opacity = 0;
      setTimeout(() => {
        this.holder.style.display = 'none';
        window.dispatchEvent(this.eventComplete)
      }, 600)
    }, 4000)
	}
}
